#import "../../../graphql/fragments/engagement-stats-fragment.graphql"

fragment EditionEngagementStats on Edition {
    id
    name
    engagementStats {
        ...EngagementStats
    }
    comparisonEdition {
        id
        comparisonPeriodEngagementStats {
            ...EngagementStats
        }
    }
    comparison {
        id
        winningMetric
        winnerEdition {
            id
        }
        engagementStats {
            ...EngagementStats
        }
        winningEdition {
            id
        }
        percentComplete
        minutesRemaining
        isTied
    }
    comparisonPeriodEngagementStats {
        ...EngagementStats
    }
}
